import { render, staticRenderFns } from "./ClassroomDetailStudentEdit.vue?vue&type=template&id=39ac26de&scoped=true"
import script from "./ClassroomDetailStudentEdit.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailStudentEdit.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailStudentEdit.vue?vue&type=style&index=0&id=39ac26de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ac26de",
  null
  
)

export default component.exports